import React, { useState } from 'react';
import { Descriptions, Modal } from 'antd';
import { RulesWithDeviceType, StbGroupExtended } from '@services/types';
import api from '@services/api';

interface Props {
  ruleModal: StbGroupExtended | undefined;
  visible: boolean;
  onClose: VoidFunction;
}

const RuleModal: React.FC<Props> = ({ visible, onClose, ruleModal }) => {
  const [ruleToUpdate, setRuleToUpdate] = useState<RulesWithDeviceType>();

  React.useEffect(() => {
    if (ruleModal?.upgradeRuleId) {
      api.rules.getRule(ruleModal.upgradeRuleId).then((rule) => {
        setRuleToUpdate(rule);
      });
    }
  }, [ruleModal?.upgradeRuleId]);

  return (
    <Modal
      title={ruleModal?.etc.upgradeRuleName}
      visible={visible}
      okText="OK"
      cancelText="Cancel"
      onCancel={onClose}
      onOk={onClose}
      width="600px"
    >
      <Descriptions
        contentStyle={{ fontSize: '16px' }}
        labelStyle={{ fontWeight: '500', fontSize: '16px' }}
        layout="horizontal"
        column={1}
      >
        <Descriptions.Item label="Name">{ruleModal?.etc.upgradeRuleName}</Descriptions.Item>
        <Descriptions.Item label="Device Type">{ruleModal?.deviceTypeName}</Descriptions.Item>
        <Descriptions.Item label="Scope">{ruleModal?.etc.superGroupName?.toLocaleUpperCase()}</Descriptions.Item>
        <Descriptions.Item label="UI/APK Version">{ruleToUpdate?.etc?.uiVersion}</Descriptions.Item>
        <Descriptions.Item label="FW Version">{ruleToUpdate?.etc?.firmwareVersion}</Descriptions.Item>
        <Descriptions.Item label="LOADER Version">{ruleToUpdate?.etc?.loaderVersion}</Descriptions.Item>
        {ruleToUpdate?.etc?.customFirmware1Version && (
          <Descriptions.Item label={ruleModal?.etc.customFirmware1Version}>
            {ruleToUpdate?.etc?.customFirmware1Version}
          </Descriptions.Item>
        )}
        {ruleToUpdate?.etc?.customFirmware2Version && (
          <Descriptions.Item label={ruleModal?.etc.customFirmware2Version}>
            {ruleToUpdate?.etc?.customFirmware2Version}
          </Descriptions.Item>
        )}
        {ruleToUpdate?.etc?.customFirmware3Version && (
          <Descriptions.Item label={ruleModal?.etc.customFirmware3Version}>
            {ruleToUpdate?.etc?.customFirmware3Version}
          </Descriptions.Item>
        )}
        <Descriptions.Item label="Forced rule">{ruleToUpdate?.forceUpdate ? 'Yes' : 'No'}</Descriptions.Item>
        <Descriptions.Item label="Send all firmwares at once">
          {ruleToUpdate?.sendAllFirmwares ? 'Yes' : 'No'}
        </Descriptions.Item>
        <Descriptions.Item label="Affected StbGroups">
          {ruleToUpdate?.stbGroups?.map((item) => item).join(', ') || 'There are no affected groups'}
        </Descriptions.Item>
      </Descriptions>
    </Modal>
  );
};

export default React.memo(RuleModal);
